import type * as Types from '../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsitePagePhotoPresentationCropInfoFragment = {
  __typename?: 'WebsitePagePhotoPresentationCropInfo';
  x: number;
  y: number;
  width: number;
  height: number;
  unit: string;
};

export type WebsitePagePhotoPresentationFragment = {
  __typename?: 'WebsitePagePhotoPresentation';
  id: string;
  presentationLayout: string;
  cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo'; x: number; y: number; width: number; height: number; unit: string } | null;
};

export type EventWebsiteGuestQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  eventDesignPurpose: Types.EventDesignPurpose;
  isAdminDashboard?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;

export type EventWebsiteGuestQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    firebaseId: string;
    website: string;
    featureFlags?: Array<string | null> | null;
    useLegacyGuestSite?: boolean | null;
    photoV2Url?: string | null;
    photoV2UrlMobile?: string | null;
    activeSession: { __typename?: 'EventSession'; id: string; hasUnlocked: boolean };
    pagesInfo?: Array<{ __typename?: 'EventPageInfo'; id: string; visibility: Types.EventPageVisibility }> | null;
    eventDesign?: {
      __typename?: 'EventDesign';
      id: string;
      hasUnpublishedChanges: boolean;
      hasVisitedDesignPage?: boolean | null;
      guestSiteTarget: Types.GuestSiteTargetEnum;
      brannanNavigation: Types.BrannanNavigation;
      useCustomTheme: boolean;
      accent?: string | null;
      customCss: string;
      linkAndButtonColor?: string | null;
      artFontColor?: string | null;
      artBackgroundColor?: string | null;
      pageBackgroundColor?: string | null;
      pageFontColor?: string | null;
      websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType; name: string };
      font: { __typename?: 'Font'; id: string; display: string; fontFamily: string; textTransform: Types.FontWeight };
      fonts?: Array<{
        __typename?: 'FontPackConfiguration';
        id: string;
        category: Types.Category;
        size?: number | null;
        sizePercent?: number | null;
        font?: { __typename?: 'Font'; id: string; fontFamily: string; fontSize: number; fontWeight: number; firebaseFontKey: string } | null;
      }> | null;
      theme: {
        __typename?: 'Theme';
        id: string;
        themeId: string;
        name: string;
        colorSchemes: Array<{ __typename?: 'ThemeColorScheme'; id: string; colors: Array<{ __typename?: 'Color'; hex: string; isLight: boolean }> }>;
        designLayouts: Array<{ __typename?: 'DesignLayout'; id: string }>;
        websiteLayoutBrannanSettings?: {
          __typename?: 'WebsiteLayoutBrannanSettings';
          brannanBackgroundTransparency?: {
            __typename?: 'DesignPreferenceRange';
            supportsCustomization: boolean;
            id: string;
            featureName: string;
            featureValueType: Types.FeatureValueType;
            rangeValue: number;
            rangeMax: number;
            rangeMin: number;
            rangeStep: number;
          } | null;
        } | null;
        websiteLayoutAlohaSettings?: {
          __typename?: 'WebsiteLayoutAlohaSettings';
          alohaColorPreference?: {
            __typename?: 'DesignPreferenceColor';
            id: string;
            featureName: string;
            featureValueType: Types.FeatureValueType;
            supportsCustomization: boolean;
            colorValue: { __typename?: 'Color'; hex: string; isLight: boolean };
          } | null;
          alohaTextColorPreference?: {
            __typename?: 'DesignPreferenceColor';
            id: string;
            featureName: string;
            featureValueType: Types.FeatureValueType;
            supportsCustomization: boolean;
            colorValue: { __typename?: 'Color'; hex: string; isLight: boolean };
          } | null;
        } | null;
      };
      colorPalette: Array<{ __typename?: 'ColorSet'; id: string; color: { __typename?: 'Color'; hex: string; isLight: boolean } }>;
      activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings'; dataJSON: any; schemaURL: string; websiteLayout: string; id: string } | null;
      customTheme?: {
        __typename?: 'CustomTheme';
        id: string;
        desktopThemeAsset?: { __typename?: 'CustomThemeAsset'; id: string; assetURL: string } | null;
        mobileThemeAsset?: { __typename?: 'CustomThemeAsset'; id: string; assetURL: string } | null;
      } | null;
      designPreferences: Array<
        | {
            __typename?: 'EventDesignPreferenceBoolean';
            id: string;
            featureId: string;
            featureName: string;
            featureType: Types.DesignFeatureType;
            featureValueType: Types.FeatureValueType;
            booleanValue: boolean;
          }
        | {
            __typename?: 'EventDesignPreferenceColorPointer';
            id: string;
            featureName: string;
            featureType: Types.DesignFeatureType;
            colorPointer?: number | null;
            colorPointerPosition?: Types.ColorPointerLocation | null;
          }
        | {
            __typename?: 'EventDesignPreferenceRange';
            id: string;
            featureId: string;
            featureName: string;
            featureType: Types.DesignFeatureType;
            featureValueType: Types.FeatureValueType;
            rangeValue: number;
          }
      >;
    } | null;
    photo?: { __typename?: 'Photo'; id: string; url: string; width: number; height: number; layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string } } | null;
    mobilePhoto?: { __typename?: 'Photo'; id: string; url: string; width: number; height: number; layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string } } | null;
    video?: { __typename?: 'Video'; id: string; url: string; title?: string | null; thumbnailUrl?: string | null; mimeType: string; caption?: string | null } | null;
    info: {
      __typename?: 'EventInfo';
      id: string;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
      eventDisplayName?: string | null;
      eventType: Types.EventType;
      location?: string | null;
      greeting?: string | null;
      timezone?: string | null;
      announcementBanner: { __typename?: 'EventAnnouncementBanner'; title: string; message: string; active: boolean };
      locationInfo?: {
        __typename?: 'EventLocation';
        id?: string | null;
        placeId?: string | null;
        name?: string | null;
        city?: string | null;
        state?: string | null;
        country?: string | null;
        address1?: string | null;
        address2?: string | null;
        latitude?: number | null;
        longitude?: number | null;
      } | null;
      tentativeDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number } | null;
      finalizedDate?: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number; timeString: string } | null;
      dateV0918?: { __typename?: 'Date'; milliseconds: number } | null;
    };
    settings: { __typename?: 'EventSettings'; id: string; hideFromSearchEngines: boolean; requiresGuestIdentification: boolean };
  } | null;
};

export const WebsitePagePhotoPresentationCropInfoFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WebsitePagePhotoPresentationFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsitePagePhotoPresentation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsitePagePhotoPresentation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cropInfo' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsitePagePhotoPresentationCropInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'x' } },
          { kind: 'Field', name: { kind: 'Name', value: 'y' } },
          { kind: 'Field', name: { kind: 'Name', value: 'width' } },
          { kind: 'Field', name: { kind: 'Name', value: 'height' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const EventWebsiteGuestDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventWebsiteGuest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventDesignPurpose' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPurpose' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isAdminDashboard' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'useLegacyGuestSite' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeSession' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasUnlocked' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagesInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventDesign' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventDesignPurpose' } } }],
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesign' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'layout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'photoV2Url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'photoV2UrlMobile' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobilePhoto' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'layout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'video' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'caption' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isAdminDashboard' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventInfoFragment' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'announcementBanner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hideFromSearchEngines' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiresGuestIdentification' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesign' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesign' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasVisitedDesignPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestSiteTarget' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brannanNavigation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useCustomTheme' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'websiteLayout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignLayout' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'font' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                { kind: 'Field', name: { kind: 'Name', value: 'textTransform' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fonts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firebaseFontKey' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizePercent' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'theme' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorSchemes' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ThemeColorScheme' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'designLayouts' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'websiteLayoutBrannanSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'brannanBackgroundTransparency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignPreferenceRange' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'supportsCustomization' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'websiteLayoutAlohaSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'alohaColorPreference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignPreferenceColor' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'alohaTextColorPreference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignPreferenceColor' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'accent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customCss' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colorPalette' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ColorSet' } }] },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsiteEventColors' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeWebsiteHeaderPresentationLayout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useCustomTheme' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTheme' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTheme' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'designPreferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceRange' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesignPreferenceRange' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ThemeColorScheme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThemeColorScheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Color' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Color' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLight' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignPreferenceRange' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignPreferenceRange' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsCustomization' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignPreferenceColor' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignPreferenceColor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsCustomization' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colorValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ColorSet' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ColorSet' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteEventColors' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesign' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'linkAndButtonColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'artFontColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'artBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageFontColor' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTheme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopThemeAsset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetURL' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileThemeAsset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetURL' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colorPointer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colorPointerPosition' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesignPreferenceRange' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceRange' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'booleanValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventInfoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'greeting' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tentativeDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'finalizedDate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'timeString' },
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'timeFormat' }, value: { kind: 'EnumValue', value: 'time' } }],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dateString' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dateV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEventWebsiteGuestQuery__
 *
 * To run a query within a React component, call `useEventWebsiteGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventWebsiteGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventWebsiteGuestQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      eventDesignPurpose: // value for 'eventDesignPurpose'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *   },
 * });
 */
export function useEventWebsiteGuestQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventWebsiteGuestQuery, EventWebsiteGuestQueryVariables>) {
  return ApolloReactHooks.useQuery<EventWebsiteGuestQuery, EventWebsiteGuestQueryVariables>(EventWebsiteGuestDocument, baseOptions);
}
export function useEventWebsiteGuestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventWebsiteGuestQuery, EventWebsiteGuestQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<EventWebsiteGuestQuery, EventWebsiteGuestQueryVariables>(EventWebsiteGuestDocument, baseOptions);
}
export type EventWebsiteGuestQueryHookResult = ReturnType<typeof useEventWebsiteGuestQuery>;
export type EventWebsiteGuestLazyQueryHookResult = ReturnType<typeof useEventWebsiteGuestLazyQuery>;
export type EventWebsiteGuestQueryResult = Apollo.QueryResult<EventWebsiteGuestQuery, EventWebsiteGuestQueryVariables>;
